import { Expose, Transform } from 'class-transformer';
import { sum } from 'lodash';

export class SnCameraStats {
  @Expose()
  public countUpCameras: number;

  @Expose()
  public countDownCameras: number;

  @Expose()
  public countUnmanagedCameras: number;

  @Expose()
  public countUnconfiguredCameras: number;

  @Expose()
  public countPendingCameras: number;

  @Expose()
  @Transform((value, data) =>
    sum([
      data.countUpCameras,
      data.countDownCameras,
      data.countUnmanagedCameras,
      data.countUnconfiguredCameras,
      data.countPendingCameras,
    ]),
  )
  public readonly totalCameras: number;

  constructor() {}
}
